import { render, staticRenderFns } from "./OccupationArea.vue?vue&type=template&id=05e1f6f2"
import script from "./OccupationArea.vue?vue&type=script&lang=js"
export * from "./OccupationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports